import React from 'react'
import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ArrowSmallIcon } from 'packages/eid-icons'

const MoreInfoButton = styled(MuiButton)(({ theme }) => ({
    width: '10.2rem',
    height: '3.1rem',
    backgroundColor: '#8b909a',
    boxShadow: '0 0 0 0',
    color: '#fff',
    textTransform: 'capitalize !important',
    borderRadius: '1.6rem',
    position: 'absolute',
    top: '-1.5rem',
    zIndex: 1,
    fontSize: '1.4rem',
    right: '2.2rem',

    '&:hover': {
        backgroundColor: '#74787e',
        color: 'white',
        '& span': {
            color: '#fff',
        },
    },
}))

const Button = ({ onClick, title }) => {
    return (
        <MoreInfoButton size="small" variant="outlined" onClick={onClick}>
            {title}
            <ArrowSmallIcon
                style={{ marginLeft: '0.5rem' }}
                fill={'white'}
                direction={'right'}
            />
        </MoreInfoButton>
    )
}

export default Button
